// Importaciones
import React from 'react';
import SecurityIcon from '@material-ui/icons/Security';

// Tipos Auth
const TYPE_LOGIN = '[Auth] Login';
const TYPE_LOGOUT = '[Auth] Logout';
const TYPE_TOKEN = 'token';
const TYPE_TOKEN_AUTH = 'authentication';
const TYPE_TOKEN_KIOSCO = 'kiosco/loginKiosco';
const TYPE_KIOSCO = 'kiosco';
const TYPE_TRAMITE = 'tramiteservice';
const INFOSESSION = 'infoSession';
const SIDUSUARIO = 'sidUsuario';
const BEARER_PREFIX = 'Bearer';
const SETTINGS_OIDC = 'settingsOidc';
const USERNAME = 'userName';

// Estados
const STATUS_APROBADO = 'Aprobado';
const STATUS_FALLIDO = 'Fallido';
const STATUS_COMPLETADA = 'COMPLETADA';
const STATUS_ENPROCESO = 'EN PROCESO';
const STATUS_CREADA = 'CREADA';
const STATUS_ERROR = 'RECHAZADA';
const STATUS_ERROR_ID = 4;

// Headers y Paths
const DEFAULT_MODE = 'cors';
const DEFAULT_CACHE = 'no-cache';
const DEFAULT_CREDENTIALS = 'same-origin';
const DEFAULT_ACCEPT = '*/*';
const DEFAULT_CONTET_TYPE = 'application/json';
const DEFAULT_CONTET_TYPE_TEXT = 'text';
const DEFAULT_SERVICES = 'services/';

// Estados de respuesta
const DEFAULT_HTTP_OK = [200, 204];
const DEFAULT_HTTP_FAIL = [400, 404];

// Metodos
const DEFAULT_POST = 'POST';
const DEFAULT_GET = 'GET';
const DEFAULT_PUT = 'PUT';
const DEFAULT_DELETE = 'DELETE';

// Botones
const DEFAULT_BLUE_COLOR = 'BLUE';
const DEFAULT_GRAY_COLOR = 'GRAY';
const DEFAULT_RED_COLOR = 'RED';
const DEFAULT_WHITE_COLOR = 'WHITE';

// Imagenes y otros
const DEFAULT_OTP_NUMBER = 'otpNumber';
const DEFAULT_SOLICITUD_ID = 'solicitudId';
const DEFAULT_TYPE_CONTENT_IMAGE = 'application/pdf';
const DEFAULT_TYPE_CONTENT_B64 = 'data:application/pdf;base64,';
const DEFAULT_POLITICAS = {
  version: '0.0.1',
  politica: [
    {
      title: 'Pólitica de privacidad',
      message: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
      icon: <SecurityIcon />,
    },
  ],
};
const DEFAULT_ERRORLOGIN = {
  title: 'Oops!!!',
  message: 'La contraseña o el usuario son invalidos, intente de nuevo por favor.',
};

export default {
  TYPE_LOGIN,
  TYPE_LOGOUT,
  TYPE_TOKEN,
  TYPE_TOKEN_AUTH,
  TYPE_TOKEN_KIOSCO,
  TYPE_KIOSCO,
  TYPE_TRAMITE,
  INFOSESSION,
  SIDUSUARIO,
  BEARER_PREFIX,
  SETTINGS_OIDC,
  USERNAME,
  STATUS_APROBADO,
  STATUS_FALLIDO,
  STATUS_COMPLETADA,
  STATUS_ENPROCESO,
  STATUS_CREADA,
  STATUS_ERROR,
  STATUS_ERROR_ID,
  DEFAULT_MODE,
  DEFAULT_CACHE,
  DEFAULT_CREDENTIALS,
  DEFAULT_ACCEPT,
  DEFAULT_CONTET_TYPE,
  DEFAULT_CONTET_TYPE_TEXT,
  DEFAULT_SERVICES,
  DEFAULT_POST,
  DEFAULT_GET,
  DEFAULT_PUT,
  DEFAULT_DELETE,
  DEFAULT_HTTP_OK,
  DEFAULT_HTTP_FAIL,
  DEFAULT_BLUE_COLOR,
  DEFAULT_GRAY_COLOR,
  DEFAULT_RED_COLOR,
  DEFAULT_WHITE_COLOR,
  DEFAULT_OTP_NUMBER,
  DEFAULT_SOLICITUD_ID,
  DEFAULT_TYPE_CONTENT_IMAGE,
  DEFAULT_TYPE_CONTENT_B64,
  DEFAULT_POLITICAS,
  DEFAULT_ERRORLOGIN,
};
